import * as React from 'react';
import * as utils from 'utils';
import { PurchaseWallpaperItem } from 'types';
import { Button, Dialog } from 'arbina-ui';
import Input from 'arbina-ui/build/components/Input';
import * as style from './style.sass';

interface Properties {
  item: PurchaseWallpaperItem;
  onClose: () => any;
  onSubmit: (item: PurchaseWallpaperItem) => any;
}

interface State {
  item: PurchaseWallpaperItem;
  previewUri: string;
}

export class ItemEditor extends React.Component<Properties> {
  state: State = {
    item: this.props.item,
    previewUri: '',
  };

  imageReference = React.createRef<HTMLImageElement>();

  onFileChosen = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;

    this.setState({
      ...this.state,
      item: {
        ...this.state.item,
        fileToUpload: file,
      },
      previewUri: file ? (await utils.getFilePreview(file)).preview : '',
    });
  }

  onSubmit = () => {
    const { item } = this.state;
    this.props.onSubmit({
      ...item,
      id: item.id ? item.id : new Date().getTime().toString(10),
    });
  }

  onPreviewLoaded = () => {
    this.setState({
      item: {
        ...this.state.item,
        width: this.imageReference.current ? this.imageReference.current.naturalWidth : 0,
        height: this.imageReference.current ? this.imageReference.current.naturalHeight : 0,
      },
    });
  }

  render() {
    const { onClose } = this.props;
    const { item, previewUri } = this.state;

    return (<Dialog
      title={`${item.id ? 'Edit' : 'Add new'} item`}
      onClose={onClose}
    >
      <div className={style.columns}>
        <div>
          <Input
            autoFocus
            type="file"
            hint="Choose item file:"
            className={style.formInput}
            onChange={this.onFileChosen}
          />
          <Input
            readOnly
            type="number"
            hint="Width:"
            className={style.formInput}
            value={item.width}
          />
          <Input
            readOnly
            type="number"
            hint="Height:"
            className={style.formInput}
            value={item.height}
          />
          <Button
            secondary
            text="OK"
            disabled={(!item.fileToUpload && !item.imageUrl) || !item.width || !item.height}
            onClick={this.onSubmit}
          />
        </div>
        {(!!previewUri || !!item.imageUrl) && <div className={style.preview}>
          <img
            src={previewUri || item.imageUrl}
            ref={this.imageReference}
            onLoad={this.onPreviewLoaded}
          />
        </div>}
      </div>
    </Dialog>);
  }
}
